<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
// import FloatButton from './components/FloatButton'

export default {
  name: 'AppMain',
  components: {
  },
  methods: {
    onFloatButton () {
      this.$router.go(-1)
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log('beforeRouteUpdate:', to, from)
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
